import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { observable, Observable, pipe } from 'rxjs';
import { BaseService } from './base.service.class';
import { NotificationService } from './notification.service';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DwhoExportDataService extends BaseService {
  private dhoApiUrl = `${environment.urlBackend}/dhoapi`;
  private dwhoUrl = `${this.dhoApiUrl}/dwho`;

  constructor(
    private http: HttpClient,
    @Inject(LOCALE_ID) private locale: string,
    protected notificationService: NotificationService
  ) {
    super(notificationService);
  }

  getDwhoData(dateIni: string, dateEnd: string): Observable<any> {
    const url = `${this.dwhoUrl}/export-data/?startDate=${dateIni}&endDate=${dateEnd}`;

    return this.http.get<Blob>(url, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  validateData(dateIni: string, dateEnd: string): Observable<any> {
    const url = `${this.dwhoUrl}/export-data/validate?startDate=${dateIni}&endDate=${dateEnd}`;

    return this.http.get<any>(url).pipe(
      tap((validation: string) => {
        catchError(this.handleError<string>(`validateData`));
      })
    );
  }
}
